'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.CreateTabs = CreateTabs;
var TabObj = {
    el: null,
    tablist: null,
    tabs: null,
    firstTab: null,
    lastTab: null,
    tabPanels: null
};

function CreateTabs() {
    var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;

    var els = context.querySelectorAll('.js-tabs');

    return Array.from(els).map(CreateTab);
}

function CreateTab(el) {
    if (!el) {
        return;
    }

    var Obj = _extends({}, TabObj);
    init.call(Obj, el);
    return Obj;
}

function init(el) {
    this.el = el;

    this.tablist = this.el.querySelector('[role=tablist]');
    this.tabs = Array.from(this.tablist.querySelectorAll('[role=tab]'));
    this.tabPanels = Array.from(this.el.querySelectorAll('[role=tabpanel]'));

    this.firstTab = this.tabs[0];
    this.lastTab = this.tabs[this.tabs.length - 1];

    this.tablist.addEventListener('keydown', onKeyDown.bind(this));
    this.tablist.addEventListener('click', onClick.bind(this));
    this.el.addEventListener('click', onNextClick.bind(this));
    setSelectedTab.call(this, this.firstTab, false);
}

function onNextClick(evt) {
    if (!evt.target.classList.contains('js-tabs-next-btn')) {
        return;
    }

    var panelId = evt.target.getAttribute('aria-controls');
    var tab = this.tabs.find(function (el) {
        return el.getAttribute('aria-controls') === panelId;
    });

    setSelectedTab.call(this, tab, true);
}

function setSelectedTab(currentTab) {
    var _this = this;

    var setFocus = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    this.tabs.forEach(function (tab, index) {
        if (currentTab === tab) {
            tab.setAttribute('aria-selected', 'true');
            tab.removeAttribute('tabindex');
            _this.tabPanels[index].classList.remove('is-hidden');
            if (setFocus) {
                tab.focus();
            }
        } else {
            tab.setAttribute('aria-selected', 'false');
            tab.tabIndex = -1;
            _this.tabPanels[index].classList.add('is-hidden');
        }
    });
}

function setSelectedToPreviousTab(currentTab) {
    if (currentTab === this.firstTab) {
        setSelectedTab.call(this, this.lastTab);
    } else {
        var index = this.tabs.indexOf(currentTab);
        setSelectedTab.call(this, this.tabs[index - 1]);
    }
}

function setSelectedToNextTab(currentTab) {
    if (currentTab === this.lastTab) {
        setSelectedTab.call(this, this.firstTab);
    } else {
        var index = this.tabs.indexOf(currentTab);
        setSelectedTab.call(this, this.tabs[index + 1]);
    }
}

function onKeyDown(evt) {
    if (evt.target.role !== 'tab') {
        return;
    }

    var stopFlag = false;
    var target = evt.target;
    switch (evt.key) {
        case 'ArrowLeft':
            setSelectedToPreviousTab.call(this, target);
            stopFlag = true;
            break;
        case 'ArrowRight':
            setSelectedToNextTab.call(this, target);
            stopFlag = true;
            break;
        case 'Home':
            setSelectedTab.call(this, this.firstTab);
            stopFlag = true;
            break;
        case 'End':
            setSelectedTab.call(this, this.lastTab);
            stopFlag = true;
            break;
    }

    if (stopFlag) {
        evt.stopPropagation();
        evt.preventDefault();
    }
}

function onClick(evt) {
    if (evt.target.role !== 'tab') {
        return;
    }

    setSelectedTab.call(this, evt.target);
}


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/src/ui/tabs.js
// module id = ./resources/assets/js/src/ui/tabs.js
// module chunks = 0